import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import { useParams } from 'react-router-dom';
import { MarkdownContent } from '@appfolio/backstage-components';
import { Typography } from '@material-ui/core';
import { useExtendedTechDocsMetadata } from '../../../../hooks/useExtendedTechDocsMetadata';

export const PageDescription = () => {
  const { entityRef } = useTechDocsReaderPage();
  const { '*': path = '' } = useParams();
  const { description, isLoading } = useExtendedTechDocsMetadata(
    entityRef,
    path,
  );
  if (isLoading) {
    return null;
  }
  return description ? (
    <Typography paragraph>
      <MarkdownContent>{description}</MarkdownContent>
    </Typography>
  ) : null;
};
